import React from 'react';
import { connect } from 'react-redux';
import {Menu, MenuItem, AsyncTypeahead} from 'react-bootstrap-typeahead';
import {groupBy, map} from 'lodash';

/*const MenuDivider = props => <li className="divider" role="separator" />;*/
const MenuHeader = props => <li {...props} className="dropdown-header" style={{color: "#ccc", backgroundColor: "#777" }} />;

class EsriAutoComplete extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            countryCode: 'USA',
            options: [],
            defaultSelected: (props.defaultSelected) ? props.defaultSelected : null,
            recentSearchClicked: props.recentSearchClicked,
            isLoading: false
        }

        this.renderOptions = this.renderOptions.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.clear = this.clear.bind(this);
    }

    componentWillReceiveProps(nextProps){
        this.setState({defaultSelected: nextProps.defaultSelected, recentSearchClicked: nextProps.recentSearchClicked});
        /*if(nextProps.defaultSelected === undefined || nextProps.defaultSelected === null || nextProps.defaultSelected === ""){
            if(this._typeahead) {
                this._typeahead.getInstance().clear();
            }
        }*/

        // hack to display defaultSelected when recent search is clicked
        if (nextProps.recentSearchClicked)
            this._instance.setState({selected: [nextProps.defaultSelected]})
    }

    renderOptions(results, menuProps) {
        if(!this.state.isLoading && !results.length) return null;

        let idx = 0;
        const grouped = groupBy(results, r => r.header);
        const items = Object.keys(grouped).sort().map(header => {
            return [
                /*!!idx && <MenuDivider key={`${header}-divider`} />,*/
                !!idx,
                <MenuHeader key={`${header}-header`}>
                    {header}
                </MenuHeader>,
                map(grouped[header], state => {
                    const item =
                        <MenuItem key={idx} option={state} position={idx}>
                            {state.text}
                        </MenuItem>;

                    idx++;
                    return item;
                }),
            ];
        });

        return <Menu {...menuProps}>{items}</Menu>;
    }

    handleSearch(query) {

        const {searchBounds, defaultMapLocation} = this.props;

        var location = '-93.2650,44.9777';
        var searchExtent = '-124.7895,49.4000,-66.0332,24.74';

        // Override national search bounds with MLS search bounds
        if(searchBounds)
            searchExtent = searchBounds;

        if(defaultMapLocation)
            location = defaultMapLocation;

        var self = this;

        if (!query) {
            self.setState({options: [], isLoading: false});
            return;
        }

        var urlPre = "https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/suggest?text=" +query;
        var urlPost = "&location=" + location +
            "&searchExtent=" + searchExtent +
            //"&countryCode=" + self.state.countryCode + 
            "&f=json&outFields=*";

        var category = "City";
        var url = urlPre + "&category=" + category + urlPost;

        //self.setState({isLoading: true});

        var resultCity = fetch(url)
                .then(resp => resp.json())
                .then(json => {
                    var cityItems = [];

                        json.suggestions.slice(0,5).forEach(function(obj){
                        var tmp = obj;
                        // ESRI Town of Fix SB: 1/31/2018
                        // ex: Brighton, Brighton, Town of, VT, USA
                        var checkFor = ', Town of, ';
                        if (tmp.text.includes(checkFor))
                        {
                            // Strip town of entry
                            tmp.text = tmp.text.replace(tmp.text.split(",")[0] + checkFor, '');
                        }

                        tmp.header = "City";                       
                        tmp.searchText = query;
                        
                        // Add if it doesn't exist
                        var existsIn = cityItems.filter(w=>w.text === tmp.text);
                        if (existsIn === undefined || existsIn.length === 0) { 
                            cityItems.push(tmp); 
                        }
                    });
                    return cityItems;
                });

        /* category = "Subregion";
        url = urlPre + "&category=" + category + urlPost;
        var resultCountry = fetch(url)
                .then(resp => resp.json())
                .then(json => {
                    var items = json.suggestions.slice(0,5).map(obj => {
                        var tmp = obj;
                        tmp.header = "Country";
                        return tmp;
                    });
                    return items;
                });

        category = "Neighborhood";
        url = urlPre + "&category=" + category + urlPost;
        var resultNeighborhood = fetch(url)
                .then(resp => resp.json())
                .then(json => {
                    var items = json.suggestions.slice(0,5).map(obj => {
                        var tmp = obj;
                        tmp.header = "Neighborhood";
                        return tmp;
                    });
                    return items;
                }); */

        category = "Primary+Postal";
        url = urlPre + "&category=" + category + urlPost;
        var resultZipcode = fetch(url)
                .then(resp => resp.json())
                .then(json => {
                    var items = json.suggestions.slice(0,5).map(obj => {
                        var tmp = obj;
                        tmp.header = "Zipcode";
                        tmp.searchText = query;
                        return tmp;
                    });
                    return items;
                });

        category = "Street+Address,Street+Name";
        url = urlPre + "&category=" + category + urlPost;
        var resultStreet = fetch(url)
                .then(resp => resp.json())
                .then(json => {
                    var items = json.suggestions.slice(0,5).map(obj => {
                        var tmp = obj;
                        tmp.header = "Street";
                        tmp.searchText = query;
                        return tmp;
                    });
                    return items;
                });

        /* Promise.all([resultCity, resultCountry, resultNeighborhood, resultZipcode, resultStreet]).then(values => {
            var resultFull = values[0].concat(values[1]).concat(values[2]).concat(values[3]).concat(values[4]);
            self.setState({options: resultFull});
        }); */
        Promise.all([resultCity, resultZipcode, resultStreet]).then(values => {
            var resultFull = values[0].concat(values[1]).concat(values[2]);
            self.setState({options: resultFull, isLoading: false});
        });

    }

    handleSubmit(e) {
        var self = this;

        if(e !== undefined && e !== null && e.length > 0 &&
            e[0] !== undefined && e[0] !== null &&
            e[0].text !== undefined && e[0].text !== null && e[0].text !== "" &&
            e[0].magicKey !== undefined && e[0].magicKey !== null && e[0].magicKey !== "") {
            var text = e[0].text;
            var mKey = e[0].magicKey;

            var url = "https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/find";
            url = url + "?magicKey=" + mKey + "&text=" + text + "&outFields=*&f=json";
            fetch(url)
                .then(response => response.json())
                .then(json => {
                    //console.log('Response:');
                    //console.log(JSON.stringify(json));

                    if(json){
                        var rangeConstant = 0;// 0.5;

                        var addrtype = json.locations[0].feature.attributes.Addr_type;
                        var addrsutype = json.locations[0].feature.attributes.Type;

                        var obj = {};
                        obj.place = {};
                        obj.place.Addr_type = json.locations[0].feature.attributes.Addr_type;
                        obj.place.Loc_name = json.locations[0].feature.attributes.Loc_name;
                        obj.place.Match_addr = json.locations[0].feature.attributes.Match_addr;
                        obj.place.Score = json.locations[0].feature.attributes.Score;
                        obj.place.Region = json.locations[0].feature.attributes.Region;
                        obj.place.X = json.locations[0].feature.attributes.X;
                        obj.place.Y = json.locations[0].feature.attributes.Y;
                        obj.place.DisplayX = json.locations[0].feature.attributes.DisplayX;
                        obj.place.DisplayY = json.locations[0].feature.attributes.DisplayY;
                        obj.place.Xmin = json.locations[0].feature.attributes.Xmin;
                        obj.place.Xmax = json.locations[0].feature.attributes.Xmax;
                        obj.place.Ymin = json.locations[0].feature.attributes.Ymin;
                        obj.place.Ymax = json.locations[0].feature.attributes.Ymax;
                        obj.PlaceSearch = {};
                        obj.PlaceSearch.addressType = json.locations[0].feature.attributes.Addr_type;
                        obj.PlaceSearch.lat = json.locations[0].feature.attributes.Y;
                        obj.PlaceSearch.lon = json.locations[0].feature.attributes.X;
                        obj.PlaceSearch.xMin = json.locations[0].feature.attributes.Xmin - rangeConstant;
                        obj.PlaceSearch.xMax = json.locations[0].feature.attributes.Xmax + rangeConstant;
                        obj.PlaceSearch.yMin = json.locations[0].feature.attributes.Ymin - rangeConstant;
                        obj.PlaceSearch.yMax = json.locations[0].feature.attributes.Ymax + rangeConstant;

                        if(addrtype.toLowerCase() === 'streetname') {
                            obj.place.City = json.locations[0].feature.attributes.City;
                            obj.place.Country = json.locations[0].feature.attributes.Country;
                            obj.place.LangCode = json.locations[0].feature.attributes.LangCode;
                            obj.place.Postal = json.locations[0].feature.attributes.Postal;
                            obj.place.StAddr = json.locations[0].feature.attributes.StAddr;
                            obj.place.StName = json.locations[0].feature.attributes.StName;
                            obj.place.StType = json.locations[0].feature.attributes.StType;
                            obj.place.Subregion = json.locations[0].feature.attributes.Subregion;

                            obj.PlaceSearch.city = json.locations[0].feature.attributes.City;
                            obj.PlaceSearch.postalcode = json.locations[0].feature.attributes.Postal;
                            obj.PlaceSearch.streetName = json.locations[0].feature.attributes.StName;
                            obj.PlaceSearch.streetType = json.locations[0].feature.attributes.StType;
                        }
                        else if(addrtype.toLowerCase() === 'streetaddress' || addrtype.toLowerCase() === 'pointaddress') {
                            obj.place.AddNum = json.locations[0].feature.attributes.AddNum;
                            obj.place.AddNumFrom = json.locations[0].feature.attributes.AddNumFrom;
                            obj.place.AddNumTo = json.locations[0].feature.attributes.AddNumTo;
                            obj.place.City = json.locations[0].feature.attributes.City;
                            obj.place.Country = json.locations[0].feature.attributes.Country;
                            obj.place.LangCode = json.locations[0].feature.attributes.LangCode;
                            obj.place.Postal = json.locations[0].feature.attributes.Postal;
                            obj.place.Side = json.locations[0].feature.attributes.Side;
                            obj.place.StAddr = json.locations[0].feature.attributes.StAddr;
                            obj.place.StName = json.locations[0].feature.attributes.StName;
                            obj.place.StType = json.locations[0].feature.attributes.StType;
                            obj.place.Subregion = json.locations[0].feature.attributes.Subregion;

                            obj.PlaceSearch.city = json.locations[0].feature.attributes.City;
                            obj.PlaceSearch.postalcode = json.locations[0].feature.attributes.Postal;
                            obj.PlaceSearch.streetName = json.locations[0].feature.attributes.StName;
                            obj.PlaceSearch.streetNumber = json.locations[0].feature.attributes.AddNum;
                            obj.PlaceSearch.streetType = json.locations[0].feature.attributes.StType;

                            if(addrtype.toLowerCase() === 'pointaddress'){
                                obj.PlaceSearch.xMin = json.locations[0].feature.attributes.Xmin - 0.005;
                                obj.PlaceSearch.xMax = json.locations[0].feature.attributes.Xmax + 0.005;
                                obj.PlaceSearch.yMin = json.locations[0].feature.attributes.Ymin - 0.005;
                                obj.PlaceSearch.yMax = json.locations[0].feature.attributes.Ymax + 0.005;
                            }
                        }
                        else if(addrtype.toLowerCase() === 'poi' || addrtype.toLowerCase() === 'locality') {
                            if(addrsutype !== null && addrsutype !== '' && (addrsutype.toLowerCase() === 'city' || addrsutype.toLowerCase() === 'state capital' || addrsutype.toLowerCase() === 'convenience store')) {
                                obj.place.Country = json.locations[0].feature.attributes.Country;
                                obj.place.PlaceName = json.locations[0].feature.attributes.PlaceName;
                                obj.place.Subregion = json.locations[0].feature.attributes.Subregion;
                                obj.place.Type = json.locations[0].feature.attributes.Type;

                                obj.PlaceSearch.city = json.locations[0].feature.attributes.PlaceName;
                            }
                            else if(addrsutype !== null && addrsutype !== '' && addrsutype.toLowerCase() === 'county') {
                                obj.place.Country = json.locations[0].feature.attributes.Country;
                                obj.place.PlaceName = json.locations[0].feature.attributes.PlaceName;
                                obj.place.Subregion = json.locations[0].feature.attributes.Subregion;
                                obj.place.Type = json.locations[0].feature.attributes.Type;

                                obj.PlaceSearch.county = json.locations[0].feature.attributes.PlaceName;
                            }
                            else if(addrsutype !== null && addrsutype !== '' && addrsutype.toLowerCase() === 'neighborhood') {
                                obj.place.Country = json.locations[0].feature.attributes.Country;
                                obj.place.PlaceName = json.locations[0].feature.attributes.PlaceName;
                                obj.place.Place_addr = json.locations[0].feature.attributes.Place_addr;
                                obj.place.Rank = json.locations[0].feature.attributes.Rank;
                                obj.place.Nbrhd = json.locations[0].feature.attributes.Nbrhd;
                                obj.place.Subregion = json.locations[0].feature.attributes.Subregion;
                                obj.place.RegionAbbr = json.locations[0].feature.attributes.RegionAbbr;
                                obj.place.LongLabel = json.locations[0].feature.attributes.LongLabel;
                                obj.place.ShortLabel = json.locations[0].feature.attributes.ShortLabel;
                                obj.place.LangCode = json.locations[0].feature.attributes.LangCode;
                                obj.place.Type = json.locations[0].feature.attributes.Type;

                                obj.PlaceSearch.state = json.locations[0].feature.attributes.Region;
                            }
                        }
                        else if(addrtype.toLowerCase() === 'postal') {
                            obj.place.City = json.locations[0].feature.attributes.City;
                            obj.place.Country = json.locations[0].feature.attributes.Country;
                            obj.place.Postal = json.locations[0].feature.attributes.Postal;

                            obj.PlaceSearch.postalcode = json.locations[0].feature.attributes.Postal;
                        }

                        if(self.props.handleAutoComplete){
                            /* obj.SearchedText = text;
                            self.props.handleAutoComplete(obj);
                            //if(self._typeahead && self.props.hideFocus) self._typeahead.getInstance().blur();
                            if(self._typeahead && self.props.hideFocus) self._typeahead.blur(); */

                            setTimeout(function() { 
                                obj.SearchedText = text;
                                self.props.handleAutoComplete(obj);
                                if(self._typeahead && self.props.hideFocus) self._typeahead.blur();
                            }, 500);
                        }
                    }

                })
                .catch(function(data){
                    console.log(data);
                });
        }
    }

    onInputChange(e) {
        if(this.props.onInputChange) {
            this.props.onInputChange(e);
        }
    }
    
    onFocus(e) {
        if(this.props.onFocus) {
            this.props.onFocus(e);
        }
    }

    onBlur(e) {
        if(this.props.onBlur) {
            this.props.onBlur(e);
        }
    }

    clear(){
        if(this._typeahead) {
            //this._typeahead.getInstance().clear();
            this._typeahead.clear();
        }        
    }

    isMLSNumber = (text) => {
        return new RegExp('^[BbRrSs][0-9]{1,7}$').test(text);
    }

    render() {

        var minLength = 3;
        /* if(this.state !== null &&
                this.state.defaultSelected !== undefined &&
                this.state.defaultSelected !== null &&                
                //this.state.defaultSelected.match("^#"))
                this.state.defaultSelected.indexOf("#") === 0)
        {
            minLength = 255;
        } */
        if(this.state !== null &&
            this.state.defaultSelected !== undefined &&
            this.state.defaultSelected !== null &&                
            this.isMLSNumber(this.state.defaultSelected))
        {
            minLength = 255;
        }

        var config = {
            className: this.props.className ? "autocomp " + this.props.className : "autocomp",
            minLength: minLength,
            align: "justify",
            maxWidth: "220px",
            options: this.state.options,
            isLoading: this.state.isLoading
        };
        if(this.state.defaultSelected !== undefined && this.state.defaultSelected !== null && this.state.defaultSelected !== ""){
            config.defaultSelected = [this.state.defaultSelected];
        }
        else{
            config.placeholder = this.props.placeholder || "Search";
        }

        return (
            <AsyncTypeahead
                ref={ref => this._typeahead = ref}
                //ref={(component) => this._instance = component ? component.getInstance() : this._typeahead }
                id="eautocomplete"
                {...config}
                clearButton
                labelKey="text"
                emptyLabel={this.state.isLoading ? "Searching..." : ""}
                useCache={false}
                filterBy={['searchText', 'text']}
                onSearch={this.handleSearch}
                renderMenu={this.renderOptions}
                onChange={this.handleSubmit}
                onInputChange={this.onInputChange}
                onBlur={this.onBlur}
                onFocus={this.onFocus}
                />
        );
    }
}

const mapStateToProps = (state, props) => ({
    searchBounds: state.settings.data['AutocompleteSearchBounds'],
    defaultMapLocation: state.settings.data['DefaultMapLocation']
});

export default connect(mapStateToProps, null, null, { withRef: true })(EsriAutoComplete);